<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M3 6H21M3 12H21M3 18H21"
            stroke="currentColor"
            stroke-width="3"
        />
    </svg>
</template>
